import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import styled from 'styled-components';
import { TotalTimeCell } from '../../common/cells/time-cells';
import { TimesheetStatus } from '../../types';

const TotalTimeCellStyled = styled(TotalTimeCell)`
  padding-left: var(--spacing-01);
  padding-right: var(--spacing-01);
`;

export const TotalTimeRenderer = (params: ICellRendererParams) => {
  const { value } = params;

  const recordValue: Record<string, number> = value.days;

  const totalMinutes = Object.values(recordValue).reduce(
    (total, day) => total + day,
    0,
  );

  if (value.status === TimesheetStatus.NotSubmitted) {
    return <></>;
  }

  return <TotalTimeCellStyled minutes={totalMinutes} />;
};
